// src/components/Navigator.tsx (UPDATED - Mode Router)

import React, { useState } from 'react';
import ModeSelector from './ModeSelector';
import ValidateNavigator from './ValidateNavigator';
import GettingStartedNavigator from './GettingStartedNavigator';

type Mode = 'validate' | 'gettingStarted' | null;

const Navigator: React.FC = () => {
  const [selectedMode, setSelectedMode] = useState<Mode>(null);

  const handleModeSelect = (mode: 'validate' | 'gettingStarted') => {
    setSelectedMode(mode);
  };

  const handleBackToModeSelection = () => {
    setSelectedMode(null);
  };

  // Show mode selector if no mode selected
  if (!selectedMode) {
    return <ModeSelector onSelectMode={handleModeSelect} />;
  }

  // Show Validate mode
  if (selectedMode === 'validate') {
    return <ValidateNavigator onBackToModes={handleBackToModeSelection} />;
  }

  // Show Getting Started mode
  return <GettingStartedNavigator onBackToModes={handleBackToModeSelection} />;
};

export default Navigator;
